import * as React from 'react';
import styled from 'styled-components';
import * as moment from 'moment';
import { colors } from 'kaizen-ui-colors/lib';
import { Tooltip } from 'react-tippy';
import { Dot } from './Dot';
import 'react-tippy/dist/tippy.css';
import { IRoundInfo, modeLabel, modeLabelColor, roundLabel } from '../../domain/entity/PortfolioReportItem';

interface IProps {
  start: Date;
  rounds: any[];
}

const Wrapper = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
`;

const Axis = styled.div`
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(0, -50%);
  width: 100%;
  height: 1px;
  background-color: ${colors.metal_lighter__b4bed5};
`;

const StartPoint = styled.div`
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(0, -50%);
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: ${colors.metal_lighter__b4bed5};
`;

const EndPoint = styled.div`
  position: absolute;
  top: 50%;
  right: 0;
  transform: translate(0, -50%);
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: ${colors.metal_lighter__b4bed5};
`;

const Round = styled.div`
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  left: 12%;
  width: 24%;
  height: 12px;
  border-left: 1px solid #fff;
`;

export class RoundTimeline extends React.PureComponent<IProps, {}> {
  private end: Date;
  private rounds: any[];
  private totalDays: number;

  constructor(props: IProps) {
    super(props);
    this.end = moment()
      .subtract(1, 'day')
      .toDate();
    this.totalDays = moment(this.end).diff(moment(this.props.start), 'days');
    this.rounds = this.props.rounds.map((round: IRoundInfo) => {
      let start = moment(round.startedAt).diff(moment(this.props.start), 'days') - 1;
      let end = round.endedAt ? moment(round.endedAt).diff(moment(this.props.start), 'days') - 1 : this.totalDays;
      start = start < 0 ? 0 : start;
      end = end < 0 ? 0 : end;
      const startPos = start / this.totalDays * 100;
      const endPos = end / this.totalDays * 100;
      return {
        id: round.id,
        num: round.num,
        type: round.type,
        startedAt: round.startedAt,
        endedAt: round.endedAt,
        startPos,
        endPos,
        mode: round.roundState.type === 'paused' ? round.roundState.type : round.purposeType,
      };
    });
  }

  public render() {
    const TooltipInnerRow = styled.tr`
      font-weight: 300;
      text-align: left;
      padding: 4px 0;
      margin: 4px 0;
    `;
    const TooltipInnerCell = styled.td`
      padding: 4px 8px;
    `;
    const TooltipInner = (
      <table>
        <tbody>
          {this.rounds.map(round => (
            <TooltipInnerRow key={round.id}>
              <TooltipInnerCell>
                <Dot color={modeLabelColor(round.mode)} />
                {roundLabel(round.type, round.num)}
              </TooltipInnerCell>
              <TooltipInnerCell>
                <span style={{ fontSize: '0.846153846rem' }}>{modeLabel(round.mode)}</span>
              </TooltipInnerCell>
              <TooltipInnerCell>
                <span style={{ fontSize: '0.846153846rem' }}>
                  {moment(round.startedAt).format('YYYY/MM/DD')} -{' '}
                  {round.endedAt ? moment(round.endedAt).format('YYYY/MM/DD') : ''}
                </span>
              </TooltipInnerCell>
            </TooltipInnerRow>
          ))}
        </tbody>
      </table>
    );
    return (
      <Tooltip
        position={'bottom'}
        theme={'light'}
        arrow={true}
        distance={4}
        duration={150}
        html={TooltipInner}
        disabled={this.rounds.length === 0}
      >
        <Wrapper>
          <Axis />
          <StartPoint />
          <EndPoint />
          {this.rounds.map(round => {
            const style = {
              left: `${round.startPos}%`,
              width: `${round.endPos - round.startPos}%`,
              backgroundColor: `${modeLabelColor(round.mode)}`,
            };
            return (
              <Round
                key={round.id}
                style={style}
                data-round-num={round.num}
                data-start-date={round.startedAt}
                data-end-date={round.endedAt}
                data-mode={round.mode}
              />
            );
          })}
        </Wrapper>
      </Tooltip>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/presentation/component/RoundTimeline.tsx